"use strict";

module.exports = function () {
  this.displayColumnsDropdown = !this.displayColumnsDropdown;
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2-premium/compiled/methods/toggle-columns-dropdown.js
// module id = 950
// module chunks = 0